import React from 'react';
import { ProgressBar, formatCurrency, LeadStatusBadge, ProjectStatusBadge } from '../../../components/common';

export const ActivitiesSection = ({ recentLeads, activeProjects }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
      {/* Recent Leads */}
      <div className="card overflow-hidden">
        <div className="flex items-center justify-between p-5 border-b border-gray-100">
          <h3 className="section-title">Recent Leads</h3>
          <a href="/leads" className="text-xs text-blum-orange font-medium hover:underline">
            View all →
          </a>
        </div>
        <div className="divide-y divide-gray-50">
          {recentLeads.map(lead => {
            const name = lead.firstName ? `${lead.firstName} ${lead.lastName || ''}`.trim() : lead.customerName || 'Unknown';
            const id = lead.customId || lead.projectId || lead._id?.substring(0, 8);
            const budget = lead.budget || lead.estimatedBudget;
            
            return (
            <div key={lead._id} className="flex justify-start items-center gap-6 py-2 px-3 hover:bg-gray-50/50 transition-colors border-b border-gray-50 last:border-0">
              {/* Avatar */}
              <div className="w-8 h-8 bg-gradient-to-br from-orange-400 to-blum-orange rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white text-xs font-bold">{name.charAt(0).toUpperCase()}</span>
              </div>
              
              {/* Col 1: Name, Phone, Email */}
              <div className="w-[260px] flex flex-col min-w-0 flex-shrink-0">
                <span className="text-brand-dark tracking-tight text-[13px] leading-tight truncate">
                  {name}
                </span>
                <span className="text-[10px] text-slate-400 truncate flex items-center mt-0.5 tracking-tighter">
                  {lead.phoneNumber || lead.phone || 'No Phone'}
                  {lead.email && <span className="opacity-50 mx-1.5">|</span>}
                  {lead.email && lead.email.toLowerCase()}
                </span>
              </div>

              {/* Col 2: Location */}
              <div className="w-[100px] flex flex-col min-w-0 text-left flex-shrink-0">
                <span className="text-[11px] text-slate-700 truncate capitalize">
                  {lead.city || (lead.location ? lead.location.split(',')[0] : '—')}
                </span>
              </div>

              {/* Col 3: Status */}
              <div className="flex-1 flex justify-start min-w-0">
                <LeadStatusBadge status={lead.status} />
              </div>
            </div>
          )})}
        </div>
      </div>

      {/* Active Projects */}
      <div className="card overflow-hidden">
        <div className="flex items-center justify-between p-5 border-b border-gray-100">
          <h3 className="section-title">Active Projects</h3>
          <a href="/projects" className="text-xs text-blum-orange font-medium hover:underline">
            View all →
          </a>
        </div>
        <div className="divide-y divide-gray-50">
          {activeProjects.map(project => {
            const id = project.customId || project.projectId || project.projectNumber || 'No ID';
            const name = project.firstName ? `${project.firstName} ${project.lastName || ''}`.trim() : project.customerName || project.siteAddress || 'No Details';
            
            return (
            <div key={project._id} className="flex justify-start items-center gap-6 py-2 px-3 hover:bg-gray-50/50 transition-colors border-b border-gray-50 last:border-0">
              {/* Col 1: ID, Name */}
              <div className="w-[200px] flex flex-col min-w-0 flex-shrink-0 pl-1">
                <span className="text-brand-dark tracking-tight text-[13px] leading-tight truncate">
                  {id.toLowerCase()}
                </span>
                <span className="text-[10px] text-slate-400 truncate flex items-center mt-0.5 tracking-tighter">
                  {name}
                </span>
              </div>

              {/* Col 2: Location */}
              <div className="w-[100px] flex flex-col min-w-0 text-left flex-shrink-0">
                <span className="text-[11px] text-slate-700 truncate capitalize">
                  {project.city || (project.location ? project.location.split(',')[0] : '—')}
                </span>
              </div>

              {/* Col 3: Progress */}
              <div className="w-[100px] flex items-center flex-shrink-0">
                <div className="w-full">
                  <ProgressBar value={project.progress || 44} />
                </div>
              </div>

              {/* Col 4: Status */}
              <div className="flex-1 flex justify-start min-w-0">
                <ProjectStatusBadge status={project.status} />
              </div>
            </div>
          )})}
        </div>
      </div>
    </div>
  );
};
